export default {
  "auth.login.title": "تسجيل الدخول",
  "auth.login.subtitle": "أدخل بيانات حساب المغسلة للوصول إلى لوحة التحكم.",
  "auth.login.email": "البريد الإلكتروني",
  "auth.login.password": "كلمة المرور",
  "auth.login.emailPlaceholder": "name@laundry.com",
  "auth.login.passwordPlaceholder": "••••••••",
  "auth.login.showPassword": "إظهار كلمة المرور",
  "auth.login.hidePassword": "إخفاء كلمة المرور",
  "auth.login.submit": "تسجيل الدخول",
  "auth.login.quickDemo": "دخول تجريبي سريع",
  "auth.login.quickDemoHint": "يدخلك مباشرة بالحساب المعتمد دون كتابة بيانات.",
  "auth.login.forgot": "نسيت كلمة المرور؟",
  "auth.login.registerLink": "تسجيل مغسلة جديدة",
  "auth.login.errorRequired": "يرجى إدخال البريد الإلكتروني وكلمة المرور.",
  "auth.login.errorInvalid": "بيانات الدخول غير صحيحة. تحقق من البريد وكلمة المرور.",
  "auth.login.errorPending": "حسابك قيد مراجعة الإدارة. سيتم إشعارك عبر البريد الإلكتروني بعد الاعتماد.",
  "auth.login.errorRejected": "تم رفض طلب انضمام المغسلة.",
  "auth.login.reasonLabel": "سبب الرفض:",
  "auth.login.demoHint": "بيانات الدخول التجريبية: laundry@laundrybox.sa / 12345678 (حساب معتمد)",
  "auth.login.demoPendingHint": "حساب قيد المراجعة: pending@laundrybox.sa / 12345678",
  "auth.login.demoRejectedHint": "حساب مرفوض: rejected@laundrybox.sa / 12345678",
  "auth.login.brandTitle": "إدارة مغسلتك بالكامل",
  "auth.login.brandText": "الطلبات، المندوبون، القطع والخدمات، والمالية في مكان واحد.",
  "auth.brand.feature.orders": "إدارة الطلبات وحالاتها من شاشة واحدة",
  "auth.brand.feature.drivers": "متابعة المندوبين التابعين والتعيين اليدوي",
  "auth.brand.feature.finance": "متابعة المالية والتسويات بوضوح",

  "auth.register.title": "تسجيل مغسلة جديدة",
  "auth.register.subtitle": "أكمل البيانات التالية وسيتم إرسال الطلب إلى الإدارة للمراجعة.",
  "auth.register.section.laundry": "بيانات المغسلة",
  "auth.register.section.address": "العنوان والتغطية",
  "auth.register.section.hours": "أوقات العمل",
  "auth.register.section.docs": "المستندات",
  "auth.register.name": "اسم المغسلة",
  "auth.register.description": "الوصف المختصر",
  "auth.register.logo": "صورة أو شعار المغسلة",
  "auth.register.phone": "رقم هاتف التواصل",
  "auth.register.email": "البريد الإلكتروني",
  "auth.register.password": "كلمة المرور",
  "auth.register.passwordHint": "٨ أحرف على الأقل.",
  "auth.register.city": "المدينة",
  "auth.register.cityPlaceholder": "اختر المدينة",
  "auth.register.mapLabel": "تحديد عنوان المغسلة عبر الخريطة",
  "auth.register.mapHint": "تعرض الخريطة الموقع وفق المدينة والحي والعنوان المُدخل.",
  "auth.register.mapSelectCityHint": "اختر المدينة أولًا ليظهر موقعك على الخريطة.",
  "auth.register.district": "الحي",
  "auth.register.street": "الشارع",
  "auth.register.building": "رقم المبنى",
  "auth.register.coverage": "الأحياء التي تغطيها المغسلة",
  "auth.register.coverageHint": "اختر الأحياء المتاحة في المدينة المحددة.",
  "auth.register.coverageEmpty": "اختر المدينة أولًا لعرض الأحياء المتاحة.",
  "auth.register.fromTime": "من الساعة",
  "auth.register.toTime": "إلى الساعة",
  "auth.register.docsHint": "المستندات المطلوبة تحدّدها الإدارة.",
  "auth.register.doc.commercial": "السجل التجاري",
  "auth.register.doc.id": "الهوية",
  "auth.register.uploadFile": "رفع ملف",
  "auth.register.replaceFile": "استبدال",
  "auth.register.removeFile": "إزالة",
  "auth.register.noFile": "لم يتم اختيار ملف",
  "auth.register.uploadRule": "الصيغ والأحجام المسموح بها قابلة للضبط بحسب خدمة الرفع في الإدارة.",
  "auth.register.submit": "إرسال طلب التسجيل",
  "auth.register.errorFix": "يرجى تصحيح الحقول المطلوبة قبل الإرسال.",
  "auth.register.passwordMismatch": "كلمتا المرور غير متطابقتين.",
  "auth.register.confirmPassword": "تأكيد كلمة المرور",
  "auth.register.reviewTitle": "طلبك قيد المراجعة",
  "auth.register.reviewText": "تم استلام طلب تسجيل المغسلة. ستراجع الإدارة البيانات والمستندات، وستُرسل نتيجة المراجعة إلى بريدك الإلكتروني.",
  "auth.register.reviewAccepted": "عند القبول يصبح تسجيل الدخول وإعداد الخدمات متاحين.",
  "auth.register.reviewToLogin": "العودة إلى تسجيل الدخول",
  "auth.register.demoNotice": "هذه معاينة ببيانات تجريبية.",

  "auth.reset.title": "استعادة كلمة المرور",
  "auth.reset.stepEmail": "البريد الإلكتروني",
  "auth.reset.stepCode": "رمز التحقق",
  "auth.reset.stepPassword": "كلمة المرور الجديدة",
  "auth.reset.emailIntro": "أدخل البريد الإلكتروني المسجل لإرسال رمز التحقق.",
  "auth.reset.sendCode": "إرسال رمز التحقق",
  "auth.reset.codeIntro": "أدخل رمز التحقق المُرسل إلى بريدك الإلكتروني.",
  "auth.reset.codeSentTo": "أُرسل رمز التحقق إلى:",
  "auth.reset.code": "رمز التحقق",
  "auth.reset.codePlaceholder": "أدخل الرمز",
  "auth.reset.verify": "تحقق",
  "auth.reset.resend": "إعادة إرسال الرمز",
  "auth.reset.validity": "صلاحية الرمز {{minutes}} دقيقة وفق إعدادات الإدارة.",
  "auth.reset.errorInvalidCode": "رمز التحقق غير صحيح.",
  "auth.reset.errorExpiredCode": "انتهت صلاحية رمز التحقق. اطلب رمزًا جديدًا.",
  "auth.reset.newPassword": "كلمة المرور الجديدة",
  "auth.reset.confirmPassword": "تأكيد كلمة المرور الجديدة",
  "auth.reset.submit": "تعيين كلمة المرور",
  "auth.reset.mismatch": "كلمتا المرور غير متطابقتين.",
  "auth.reset.successTitle": "تم تعيين كلمة المرور",
  "auth.reset.successText": "يمكنك الآن تسجيل الدخول باستخدام كلمة المرور الجديدة.",
  "auth.reset.toLogin": "الانتقال إلى تسجيل الدخول",
  "auth.reset.backToLogin": "العودة إلى تسجيل الدخول",
  "auth.reset.demoNotice": "هذه معاينة ببيانات تجريبية."
};